/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Merge_LabelInputs */



/**
* | output |
* | --- |
* | "Merge" |
*
* @param {Plain_Text_Import_Merge_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_merge_label = /** @type {((inputs?: Plain_Text_Import_Merge_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Merge_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verschmelzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слияние")
	if (locale === "es") return /** @type {LocalizedString} */ ("Unir")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合并")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マージ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मर्ज")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fusão")
	return /** @type {LocalizedString} */ ("Merge")
});